import { lazy } from "react";
import { Route } from "react-router-dom";
import RouteGuard from "@/components/RouteGuard";

const AlunoDashboard = lazy(() => import("@/pages/AlunoDashboard"));
const AlunoTurmasLista = lazy(() => import("@/pages/AlunoTurmasLista"));
const AlunoTurmaDetalhe = lazy(() => import("@/pages/AlunoTurmaDetalhe"));
const AlunoFinanceiro = lazy(() => import("@/pages/AlunoFinanceiro"));
const AlunoPerfil = lazy(() => import("@/pages/AlunoPerfil"));
const AlunoPresencas = lazy(() => import("@/pages/AlunoPresencas"));
const AlunoProgresso = lazy(() => import("@/pages/AlunoProgresso"));
const AlunoAcademia = lazy(() => import("@/pages/AlunoAcademia"));
const AlunoProfessorDetalhe = lazy(() => import("@/pages/AlunoProfessorDetalhe"));
const AlunoConfiguracoes = lazy(() => import("@/pages/AlunoConfiguracoes"));
const AlunoSuporte = lazy(() => import("@/pages/AlunoSuporte"));
const AlunoNotificacoes = lazy(() => import("@/pages/AlunoNotificacoes"));
const AlunoMetas = lazy(() => import("@/pages/AlunoMetas"));
const AlunoEventos = lazy(() => import("@/pages/AlunoEventos"));
const AlunoAssistente = lazy(() => import("@/pages/AlunoAssistente"));
const JornadaAluno = lazy(() => import("@/pages/JornadaAluno"));
const AlunoDocumentosPendentes = lazy(() => import("@/pages/AlunoDocumentosPendentes"));
const AlunoMensagens = lazy(() => import("@/pages/AlunoMensagens"));

const roles = ["developer", "aluno"] as const;
const G = ({ children }: { children: React.ReactNode }) => (
  <RouteGuard allowedRoles={[...roles]}>{children}</RouteGuard>
);

export const alunoRoutes = (
  <>
    <Route path="/aluno_dashboard" element={<G><AlunoDashboard /></G>} />
    <Route path="/aluno_turmas" element={<G><AlunoTurmasLista /></G>} />
    <Route path="/aluno_turma_detalhe" element={<G><AlunoTurmaDetalhe /></G>} />
    <Route path="/aluno_turma/:id" element={<G><AlunoTurmaDetalhe /></G>} />
    <Route path="/aluno_financeiro" element={<G><AlunoFinanceiro /></G>} />
    <Route path="/aluno_perfil" element={<G><AlunoPerfil /></G>} />
    <Route path="/aluno_presencas" element={<G><AlunoPresencas /></G>} />
    <Route path="/aluno_progresso" element={<G><AlunoProgresso /></G>} />
    <Route path="/aluno_academia" element={<G><AlunoAcademia /></G>} />
    <Route path="/aluno_professor_detalhe" element={<G><AlunoProfessorDetalhe /></G>} />
    <Route path="/aluno_professor/:id" element={<G><AlunoProfessorDetalhe /></G>} />
    <Route path="/aluno_configuracoes" element={<G><AlunoConfiguracoes /></G>} />
    <Route path="/aluno_suporte" element={<G><AlunoSuporte /></G>} />
    <Route path="/aluno_notificacoes" element={<G><AlunoNotificacoes /></G>} />
    <Route path="/jornada_aluno" element={<G><JornadaAluno /></G>} />
    <Route path="/aluno_metas" element={<G><AlunoMetas /></G>} />
    <Route path="/aluno_eventos" element={<G><AlunoEventos /></G>} />
    <Route path="/aluno_assistente" element={<G><AlunoAssistente /></G>} />
    <Route path="/aluno_documentos_pendentes" element={<G><AlunoDocumentosPendentes /></G>} />
    <Route path="/aluno_mensagens" element={<G><AlunoMensagens /></G>} />
  </>
);
